import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getRoles() {
        try{            
            const response = await axios.get(`TeamRoles/roles`,
            {
                headers: {
                    'page_key': pageKeys.team_roles
                }
            })                              
            return response
        }catch (error){
            console.log('TeamRoles api getRoles error')
            throw error
        }
    },
    async upsertRole(data) {
        try{            
            const response = await axios.post(`TeamRoles/role`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.team_roles
                }
            })                              
            return response
        }catch (error){
            console.log('TeamRoles api upsertRole error')
            throw error
        }
    },
    async updatePermissions(data) {
        try{            
            const response = await axios.post(`TeamRoles/permission`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.team_roles
                }
            })                              
            return response
        }catch (error){
            console.log('TeamRoles api updatePermissions error')
            throw error
        }
    },
    async getPermissions(teamRoleId) {
        try{            
            const response = await axios.get(`TeamRoles/permissions/${teamRoleId}`,
            {
                headers: {
                    'page_key': pageKeys.team_roles
                }
            })                              
            return response
        }catch (error){
            console.log('TeamRoles api getPermissions error')
            throw error
        }
    },
}